<div class="card">
    <app-quotation-details></app-quotation-details>
</div>
